// extracted by mini-css-extract-plugin
export default {"AccountLayout":"AccountLayout_AccountLayout__2+EjI","AccountMain":"AccountLayout_AccountMain__y7PDy"};